const processes = (a: {label: string}, curInfoData: {optgroup: string, label: string}[] ) => {
    switch(a.label){
        case "Casting Impregnation":
            return ["CLEANING",
        ...(curInfoData).filter(v => v.optgroup === a.label).map((v, i) => `Proccess ${i + 1} for ${v.label}`),
        "POST CLEANING", "PACKAGE", "LAB REPORT"];
        case "Chemical Analysis":
            return ["CLEANING",
        ...(curInfoData).filter(v => v.optgroup === a.label).map((v, i) => `Proccess ${i + 1} for ${v.label}`),
        "POST CLEANING", "PACKAGE", "LAB REPORT"];
        case "Concrete Cutting":
            return ["CLEANING",
        ...(curInfoData).filter(v => v.optgroup === a.label).map((v, i) => `Proccess ${i + 1} for ${v.label}`),
        "POST CLEANING", "PACKAGE", "LAB REPORT"]; 
        case "Concrete Scanning Services":
            return ["CLEANING",
        ...(curInfoData).filter(v => v.optgroup === a.label).map((v, i) => `Proccess ${i + 1} for ${v.label}`),
        "POST CLEANING", "PACKAGE", "LAB REPORT"];
        case "Corrosion":
            return ["CLEANING",
        ...(curInfoData).filter(v => v.optgroup === a.label).map((v, i) => `Proccess ${i + 1} for ${v.label}`),
        "POST CLEANING", "PACKAGE", "LAB REPORT"];
        case "Dimensional Inspection":
            return ["CLEANING",
        ...(curInfoData).filter(v => v.optgroup === a.label).map((v, i) => `Proccess ${i + 1} for ${v.label}`),
        "POST CLEANING", "PACKAGE", "LAB REPORT"];
        case "Material & Failure Analysis":
            return ["CLEANING",
        ...(curInfoData).filter(v => v.optgroup === a.label).map((v, i) => `Proccess ${i + 1} for ${v.label}`),
        "POST CLEANING", "PACKAGE", "LAB REPORT"];
        case "Metallography":
            return ["CLEANING",
        ...(curInfoData).filter(v => v.optgroup === a.label).map((v, i) => `Proccess ${i + 1} for ${v.label}`),
        "POST CLEANING", "PACKAGE", "LAB REPORT"];
        case "Miscellaneous":
            return ["CLEANING",
        ...(curInfoData).filter(v => v.optgroup === a.label).map((v, i) => `Proccess ${i + 1} for ${v.label}`),
        "POST CLEANING", "PACKAGE", "LAB REPORT"];
        case "Non-Destructive Testing":
            return ["CLEANING",
        ...(curInfoData).filter(v => v.optgroup === a.label).map((v, i) => `Proccess ${i + 1} for ${v.label}`),
        "POST CLEANING", "PACKAGE", "LAB REPORT"];
        case "Physical Testing":
            return ["CLEANING",
        ...(curInfoData).filter(v => v.optgroup === a.label).map((v, i) => `Proccess ${i + 1} for ${v.label}`),
        "POST CLEANING", "PACKAGE", "LAB REPORT"];
        case "Plating Analysis":
            return ["CLEANING",
        ...(curInfoData).filter(v => v.optgroup === a.label).map((v, i) => `Proccess ${i + 1} for ${v.label}`),
        "POST CLEANING", "PACKAGE", "LAB REPORT"];
        case "Welding Inspection":
            return ["CLEANING",
        ...(curInfoData).filter(v => v.optgroup === a.label).map((v, i) => `Proccess ${i + 1} for ${v.label}`),
        "POST CLEANING", "PACKAGE", "LAB REPORT"];
        default:
            return []
    }
}

export default processes;